import { Link } from "react-router";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Loader } from "@/components/ui/loader";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { UserContext } from "@/contexts/UserContext";
import { useContext } from "react";
import type { CurrentUserOrg } from "@/types/index";
import { OrgStatsComponent } from "@/components/org/OrgStatsComponent";
import { BackButton } from "@/components/ui/BackButton";

export function UserOrgs() {
  const { currentUser, isLoadingUser } = useContext(UserContext);

  if (isLoadingUser) return <Loader />;

  if (!currentUser?.organisations || currentUser.organisations.length === 0) {
    return <div className="p-4 text-center text-muted-foreground">No organisations found.</div>;
  }

  return (
    <div className="space-y-4 max-w-2xl mx-auto">
      <div className="flex flex-row items-center justify-between">
        <BackButton />
        <h1 className="text-2xl font-bold ">Your Organisations</h1>
        <div className="size-6"></div>

      </div>
      <div className="grid gap-4">
        {currentUser.organisations.map((org: CurrentUserOrg) => (
          <Card key={org.orgId}>
            <CardHeader>
              <CardTitle>{org.orgName}</CardTitle>
            </CardHeader>
            <CardContent>
              <OrgStatsComponent orgId={org.orgId} />
              <Link
                className="text-primary underline hover:no-underline"
                to={`/app/org/${org.orgId}`}
              >
                View Organisation
              </Link>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
